// SEO-1910b — single indexability policy for programmatic city/country pages.
// Imported by the app (seo-indexability.ts → SEOHead) AND by the sitemap
// scripts, so the sitemap never lists a URL the page itself marks noindex.
//
// A route is "thin" (noindex,follow + out of every sitemap, in all languages)
// when it is a templated city/country page AND it has never received a Google
// impression AND it is not a priority market. Decided per route, not per
// language, so hreflang clusters stay complete and reciprocal.
import impressionRoutes from '../data/seo-impression-routes.json' with { type: 'json' };

const PROGRAMMATIC_GEO = /^(software-development-agency-|softwareentwicklung-agentur-|call-center-for-|callcenter-|centre-appel-|centro-llamadas-|cagri-merkezi-|call-center-(?!(automotive|ecommerce|education|energy|fintech|gaming|government|healthcare|insurance|logistics|media|nonprofit|pharma|real-estate|saas|telecom|travel|service|seobiseu|europe|americas)$))[a-z0-9-]+$/;

// Priority markets (Mohamed 19/10): Belgium, France, Netherlands, Spain, UK, Gulf.
// Dubai is excluded on purpose: it belongs exclusively to UBTIS.
const PRIORITY_MARKET = /(belg|brussel|fran|paris|nether|niederland|pays-bas|paises-bajos|paesi-bassi|holand|hollanda|amsterdam|spain|espa|spagna|hiszpania|ispanya|madrid|barcelona|united-kingdom|-uk$|royaume-uni|reino-unido|regno-unito|wielka-brytania|ingiltere|storbritannien|london|saudi|saudy|arabie|arabia|suudi|ksa|riyadh|jeddah|qatar|katar|catar|doha|kuwait|bahr|oman|muscat|emirat|emirad|uae$|-bae$|abu-dhabi|zea$)/;

const KEEP = new Set(impressionRoutes);

// Legacy redirect routes (QUOTE-1910c): served as redirects to /start, never indexed or listed.
const LEGACY_REDIRECTS = new Set(['quote', 'get-a-quote']);

// REVIEW-1910d (Mohamed 19/10 16:37): the mass city/country reduction stays in
// review, NOT active in production. Legacy /quote redirects stay active.
export const THIN_GEO_POLICY_ENABLED = false;

/** Same decision as isThinRoute with the geo policy forced on — review inventory only. */
export function isThinRouteCandidate(routePath) {
  if (!routePath || !PROGRAMMATIC_GEO.test(routePath)) return false;
  if (routePath.includes('dubai')) return true;
  if (KEEP.has(routePath)) return false;
  return !PRIORITY_MARKET.test(routePath);
}

export function isThinRoute(routePath) {
  if (LEGACY_REDIRECTS.has(routePath)) return true;
  if (THIN_GEO_POLICY_ENABLED) return isThinRouteCandidate(routePath);
  return false;
}

function _unusedLegacy(routePath) {
  if (!routePath || !PROGRAMMATIC_GEO.test(routePath)) return false;
  if (routePath.includes('dubai')) return true;
  if (KEEP.has(routePath)) return false;
  return !PRIORITY_MARKET.test(routePath);
}
